import profile from '../../Assets/Images/Artists/01/profile_hidden.jpg'
import p1Img1 from '../../Assets/Images/Artists/01/projects/01/1.jpg'
import p1Img2 from '../../Assets/Images/Artists/01/projects/01/2.jpg'
import p1Img3 from '../../Assets/Images/Artists/01/projects/01/3.jpg'
import p1Img4 from '../../Assets/Images/Artists/01/projects/01/4.jpg'
import p1Img5 from '../../Assets/Images/Artists/01/projects/01/5.jpg'
import p1Img6 from '../../Assets/Images/Artists/01/projects/01/6.jpg'
import p1Img7 from '../../Assets/Images/Artists/01/projects/01/7.jpg'
import p1Img8 from '../../Assets/Images/Artists/01/projects/01/8.jpg'
import p1Img9 from '../../Assets/Images/Artists/01/projects/01/9.jpg'

const projectOneImages = [
  p1Img1,
  p1Img2,
  p1Img3,
  p1Img4,
  p1Img5,
  p1Img6,
  p1Img7,
  p1Img8,
  p1Img9,
]

const project1 = {
  title: 'untitled',
  year: 2017,
  content: [
    {
      type: 'image',
      images: [...projectOneImages]
    },
  ]
}

const projects = [
  project1
]

const user = {
  username: 'sprks',
  name: 'Sparkes J.',
  url: 'https://www.jordansparkes.co.uk/',
  avatar: profile,
  seen: false,
  anonymous: true,
  projects: projects
}

export default user



// WEBPACK FOOTER //
// ./src/Data/Users/sprks.js